import TicketConstants from "../Constants/TicketConstants";
import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";

class TicketActions {
  getAllTicket(_status, equipGrpId) {
    httpRequest(
      config.webServiceURL + "/Ticket/GetTickets/" + _status + "/" + equipGrpId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: TicketConstants.GET_TICKET_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: TicketConstants.GET_TICKET_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getTicketDetails(ticketId, userId, language, isPublic) {
    httpRequest(
      config.webServiceURL +
        "/Ticket/GetTicket/" +
        ticketId +
        "?u=" +
        userId +
        "&language=" +
        language +
        "&isPublic=" +
        isPublic,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: TicketConstants.GET_TICKET_DETAILS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: TicketConstants.GET_TICKET_DETAILS_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  UpdateStatus(DataObj, isPublic, language, detailspage) {
    httpRequest(
      config.webServiceURL +
        "/Ticket/UpdateStatus/" +
        DataObj.id +
        "/" +
        DataObj.status +
        "?isPublic=" +
        isPublic +
        "&language=" +
        language +
        "&closeReason=" +
        DataObj.reason,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: isPublic
              ? TicketConstants.UPDATE_PUBLIC_TICKET_STATUS_SUCCESS
              : detailspage
              ? TicketConstants.UPDATE_TICKET_STATUS_DETAIL_SUCCESS
              : TicketConstants.UPDATE_TICKET_STATUS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: isPublic
              ? TicketConstants.UPDATE_PUBLIC__TICKET_STATUS_FAILURE
              : detailspage
              ? TicketConstants.UPDATE_TICKET_STATUS_DETAIL_FAILURE
              : TicketConstants.UPDATE_TICKET_STATUS_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  UpdateBulkStatus(DataObj) {
    httpRequest(
      config.webServiceURL + "/Ticket/UpdateBulkStatus/",
      "PUT",
      JSON.stringify({
        TicketIds: DataObj.id,
        Status: DataObj.status,
        closeReason: DataObj.reason,
      }),
      // JSON.stringify({ Status DataObj }),

      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: TicketConstants.UPDATE_MUL_TICKET_STATUS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: TicketConstants.UPDATE_MUL_TICKET_STATUS_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getEquipmentTickets(anlageId) {
    httpRequest(
      config.webServiceURL + "/Ticket/GetEquipmentTickets/" + anlageId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: TicketConstants.GET_EQUIPMENT_TICKET_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: TicketConstants.GET_EQUIPMENT_TICKET_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new TicketActions();
